<template>
  <ReportLayoutModerno 
    id="reportList" 
    :prefecture="prefecture" 
    :period="convertDate(filter.startDate) + ' até ' + convertDate(filter.endDate)"
  >
    <template v-slot:title>RELATÓRIO GERAL</template>
    <template v-slot:sub-header>
      <h3 class="text-sm font-bold text-slate-600">
        Fornecedor: <span class="text-orange-600 uppercase">{{ provider && provider.provider_name ? provider.provider_name : '' }}</span>
      </h3>
    </template>

    <!-- ÁREAS POR SETOR -->
    <div v-for="(d, i) in data.secs" :key="i" class="mb-12 break-inside-avoid">
      <div class="bg-slate-800 text-white px-6 py-3 rounded-t-xl flex items-center justify-between">
        <span class="text-[10px] font-black uppercase tracking-[0.2em]">SETOR</span>
        <span class="text-sm font-bold uppercase">{{ d.sec_name }}</span>
      </div>

      <div class="border border-slate-200 border-t-0 rounded-b-xl overflow-hidden">
        <div v-for="(vehicle, ix) in d.vehicles" :key="ix" class="border-b border-slate-100 last:border-0 p-6">
          <!-- INFO DO VEÍCULO -->
          <div class="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6 bg-slate-50 p-4 rounded-xl border border-slate-100">
            <div class="flex flex-col">
              <span class="text-[9px] font-black text-slate-400 uppercase tracking-tighter">SUBSETOR</span>
              <span class="text-xs font-bold text-slate-700 uppercase">{{ vehicle.subsec_desc || '---' }}</span>
            </div>
            <div class="flex flex-col">
              <span class="text-[9px] font-black text-slate-400 uppercase tracking-tighter">VEÍCULO</span>
              <span class="text-xs font-bold text-slate-700 uppercase">{{ vehicle.brand_desc }}</span>
            </div>
            <div class="flex flex-col">
              <span class="text-[9px] font-black text-slate-400 uppercase tracking-tighter">MODELO</span>
              <span class="text-xs font-bold text-slate-700 uppercase">{{ vehicle.model_desc }}</span>
            </div>
            <div class="flex flex-col">
              <span class="text-[9px] font-black text-slate-400 uppercase tracking-tighter">PLACA</span>
              <span class="text-xs font-black text-orange-600 uppercase tracking-wider">{{ vehicle.vehicle_board }}</span>
            </div>
          </div>

          <!-- TABELA DE ABASTECIMENTOS -->
          <table class="w-full text-left border-collapse">
            <thead>
              <tr class="bg-slate-50 border-b border-slate-200">
                <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider">Combustível</th>
                <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider">Data</th>
                <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider text-right">Lts</th>
                <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider text-right">P. Licitado</th>
                <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider text-right">Total Licitado</th>
                <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider text-right">Preço Dia</th>
                <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider text-right">Total Dia</th>
                <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider center">Cupom</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(supply, sx) in vehicle.supplies" :key="sx" class="border-b border-slate-50 hover:bg-slate-50/50 transition-colors">
                <td class="p-3 text-xs font-bold text-slate-700">{{ supply.item_description_desc }}</td>
                <td class="p-3 text-[10px] text-slate-500 font-medium">{{ convertDateTime(supply.datehour) }}</td>
                <td class="p-3 text-xs font-black text-slate-700 text-right">{{ supply.supply_liters_stocked ? realMaskII(supply.supply_liters_stocked.toFixed(3)) : 0 }}</td>
                <td class="p-3 text-[10px] text-slate-600 text-right">{{ supply.supply_bidding_price ? realMaskII(supply.supply_bidding_price.toFixed(3)) : 0 }}</td>
                <td class="p-3 text-xs font-black text-slate-900 text-right">R$ {{ realMask((supply.supply_bidding_value).toFixed(2)) }}</td>
                <td class="p-3 text-[10px] text-slate-600 text-right">{{ supply.supply_price_day ? realMaskII((supply.supply_price_day).toFixed(3)) : 0 }}</td>
                <td class="p-3 text-xs font-black text-orange-600 text-right font-mono">R$ {{ supply.supply_value ? realMask((supply.supply_value).toFixed(2)) : 0 }}</td>
                <td class="p-3 text-[10px] text-slate-500 text-center font-bold">{{ supply.supply_coupon }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="bg-slate-50/80 font-black text-slate-800 border-t border-slate-200">
                <td colspan="2" class="p-3 text-[10px] uppercase">TOTAIS DO VEÍCULO</td>
                <td class="p-3 text-xs text-right text-slate-900">{{ vehicle.totals.total_liters ? realMaskII(vehicle.totals.total_liters.toFixed(3)) : 0 }}</td>
                <td></td>
                <td class="p-3 text-xs text-right text-slate-900 font-mono">R$ {{ vehicle.totals.billing_value ? realMask(vehicle.totals.billing_value.toFixed(2)) : 0 }}</td>
                <td></td>
                <td class="p-3 text-xs text-right text-orange-600 font-mono">R$ {{ vehicle.totals.total_value ? realMask(vehicle.totals.total_value.toFixed(2)) : 0 }}</td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>

    <!-- RESUMOS FINAIS -->
    <div class="mt-12 break-inside-avoid shadow-inner p-8 bg-slate-50 rounded-2xl border border-slate-100">
      <h2 class="text-lg font-black text-slate-800 uppercase tracking-widest text-center mb-8">RESUMOS DO PERÍODO</h2>
      
      <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
        <!-- RESUMO PREÇO LICITADO -->
        <div class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
          <div class="bg-slate-800 px-4 py-2 text-center">
            <span class="text-[9px] font-black text-white uppercase tracking-[0.2em]">RESUMO PREÇO LICITADO</span>
          </div>
          <table class="w-full text-xs text-left">
            <thead>
              <tr class="bg-slate-50 border-b border-slate-100">
                <th class="p-4 font-black uppercase text-[10px] text-slate-500">Tipo</th>
                <th class="p-4 font-black uppercase text-[10px] text-slate-500 text-right">Licitado</th>
                <th class="p-4 font-black uppercase text-[10px] text-slate-500 text-right">Total Lts</th>
                <th class="p-4 font-black uppercase text-[10px] text-slate-500 text-right">Valor Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(resume, idx) in data.resume" :key="idx" class="border-b border-slate-50">
                <td class="p-4 font-bold text-slate-700 uppercase">{{ resume.item_description_desc }}</td>
                <td class="p-4 text-right text-slate-600">{{ resume.supply_bidding_price ? realMaskII(resume.supply_bidding_price.toFixed(3)) : 0 }}</td>
                <td class="p-4 text-right text-slate-600 font-bold">{{ resume.litersStocked ? realMask(resume.litersStocked.toFixed(2)) : 0 }}</td>
                <td class="p-4 text-right text-slate-900 font-black font-mono">R$ {{ resume.totalBillingPrice ? realMask(resume.totalBillingPrice.toFixed(2)) : 0 }}</td>
              </tr>
            </tbody>
            <tfoot v-if="data.resumeTotals">
              <tr class="bg-orange-50 font-black border-t border-orange-100 text-orange-700">
                <td class="p-4 uppercase text-[10px]">TOTAL ACUMULADO</td>
                <td></td>
                <td class="p-4 text-right font-black">{{ data.resumeTotals.totalLiters ? realMask(data.resumeTotals.totalLiters.toFixed(2)) : 0 }}</td>
                <td class="p-4 text-right font-black font-mono text-base">R$ {{ data.resumeTotals.totalBidding ? realMask(data.resumeTotals.totalBidding.toFixed(2)) : 0 }}</td>
              </tr>
            </tfoot>
          </table>
        </div>

        <!-- RESUMO PREÇO DIA -->
        <div class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
          <div class="bg-orange-600 px-4 py-2 text-center">
            <span class="text-[9px] font-black text-white uppercase tracking-[0.2em]">RESUMO PREÇO DIA</span>
          </div>
          <table class="w-full text-xs text-left">
            <thead>
              <tr class="bg-slate-50 border-b border-slate-100">
                <th class="p-4 font-black uppercase text-[10px] text-slate-500">Tipo</th>
                <th class="p-4 font-black uppercase text-[10px] text-slate-500 text-right">Preço Dia</th>
                <th class="p-4 font-black uppercase text-[10px] text-slate-500 text-right">Total Lts</th>
                <th class="p-4 font-black uppercase text-[10px] text-slate-500 text-right">Valor Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(resume, idx) in data.resume" :key="idx" class="border-b border-slate-50">
                <td class="p-4 font-bold text-slate-700 uppercase">{{ resume.item_description_desc }}</td>
                <td class="p-4 text-right text-slate-600">{{ resume.supply_price_day ? realMaskII(resume.supply_price_day.toFixed(3)) : 0 }}</td>
                <td class="p-4 text-right text-slate-600 font-bold">{{ resume.litersStocked ? realMask(resume.litersStocked.toFixed(2)) : 0 }}</td>
                <td class="p-4 text-right text-slate-900 font-black font-mono">R$ {{ resume.totalPriceDay ? realMask(resume.totalPriceDay.toFixed(2)) : 0 }}</td>
              </tr>
            </tbody>
            <tfoot v-if="data.resumeTotals">
              <tr class="bg-indigo-50 font-black border-t border-indigo-100 text-indigo-700">
                <td class="p-4 uppercase text-[10px]">TOTAL DIA ACUMULADO</td>
                <td></td>
                <td class="p-4 text-right font-black">{{ data.resumeTotals.totalLiters ? realMask(data.resumeTotals.totalLiters.toFixed(2)) : 0 }}</td>
                <td class="p-4 text-right font-black font-mono text-base">R$ {{ data.resumeTotals.totalDay ? realMask(data.resumeTotals.totalDay.toFixed(2)) : 0 }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </ReportLayoutModerno>
</template>

<script>
import helpers from "../../../mixins/helpers";
import ReportLayoutModerno from "@/components/ReportLayoutModerno.vue";

export default {
  components: {
    ReportLayoutModerno
  },
  props: ["data","filter", "prefecture", "provider"],
  mixins: [helpers],
  methods: {
    initialize() {
      this.helpers;
    },
  },
};
</script>

<style></style>